// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
const dotenv = require("dotenv");
require("dotenv").config();
module.exports = `${process.env.REACT_APP_USER_LOG_API}`;
